import React, { Component } from "react";
import { Button, Glyphicon, Modal, Alert } from "react-bootstrap";
import Files from "react-files";
import Client from "../../../Client";
import Completed from "./upload/Completed";
import Processing from "./upload/Processing";
import Error from "./upload/Error";
import FileDisplay from "./upload/FileDisplay";
import "./runsheet_upload.css";

class RunsheetUpload extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onFilesChange = this.onFilesChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.handleUploadError = this.handleUploadError.bind(this);
    this.handleUploadSuccess = this.handleUploadSuccess.bind(this);

    this.state = {
      view: "SELECT_FILE",
      show: false,
      files: [],
      error: "",
      errors: [],
      uploadData: {
        summary: {
          runsheets: 0,
          jobs: 0,
          items: 0
        },
        warnings: []
      }
    };
  }

  onFilesChange(files) {
    const file = files[0];
    if (file.extension === "xls" || file.extension === "xlsx") {
      this.setState({ files, error: "", view: "FILE_SELECTED" });
    } else {
      this.setState({ error: `Invalid file format: ${file.extension}` });
    }
  }

  handleClose() {
    this.setState({
      show: false,
      files: [],
      error: "",
      errors: [],
      view: "SELECT_FILE"
    });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleUploadError(response) {
    if (response.status === 400) {
      this.setState({
        error: "",
        errors: response.data.errors,
        feedback: response.data.feedback,
        view: "VALIDATION_ERROR",
        files: []
      });
    } else {
      this.setState({
        error:
          "There was an error processing your request. Check that the file is in the correct format",
        view: "FILE_SELECTED"
      });
    }
  }

  handleUploadSuccess(response) {
    const uploadData = { ...this.state.data, ...response.data };
    this.setState({
      uploadData,
      view: "UPLOAD_COMPLETE"
    });
  }

  handleUpload() {
    const files = this.state.files;
    if (files.length) {
      this.setState({ view: "UPLOADING" });
      const file = files[0];
      const formData = new FormData();
      formData.append("file", file, file.name);

      Client.uploadRunsheet(formData)
        .then(response => this.handleUploadSuccess(response))
        .catch(error => this.handleUploadError(error.response));
    } else {
      this.setState({ error: "Provide file first" });
    }
  }

  removeFile() {
    this.setState({ files: [], error: "", view: "SELECT_FILE" });
  }

  render() {
    let modalBody;
    let modalButton;
    const file = this.state.files[0];

    switch (this.state.view) {
      case "FILE_SELECTED":
        modalBody = (
          <div>
            {this.state.error && (
              <Alert bsStyle="danger" className="custom-alert">
                <p>{this.state.error}</p>
              </Alert>
            )}
            <FileDisplay file={file} onRemove={this.removeFile} />
          </div>
        );
        modalButton = (
          <Button bsStyle="primary" onClick={this.handleUpload}>
            Upload
          </Button>
        );
        break;
      case "UPLOADING":
        modalBody = <Processing />;
        modalButton = "";
        break;
      case "VALIDATION_ERROR":
        modalBody = (
          <div>
            <Error errors={this.state.errors} feedback={this.state.feedback} />
            <div className="dropzone-container">
              <Files
                className="files-dropzone"
                onChange={this.onFilesChange}
                multiple={false}
                clickable
              >
                Drop file in this space or click to browse for a file on your
                computer
              </Files>
            </div>
          </div>
        );
        modalButton = (
          <Button bsStyle="primary" onClick={this.handleUpload}>
            Upload
          </Button>
        );
        break;
      case "UPLOAD_COMPLETE":
        modalBody = <Completed data={this.state.uploadData} />;
        modalButton = (
          <Button bsStyle="primary" onClick={this.handleClose}>
            Close
          </Button>
        );
        break;
      default:
        modalBody = (
          <div>
            {this.state.error && (
              <Alert bsStyle="danger" className="custom-alert">
                <p>{this.state.error}</p>
              </Alert>
            )}
            <div>
              <p>
                You have the ability to upload multiple runsheets, that all{" "}
                include jobs and items within, all at once. This batch upload{" "}
                requires an Excel file to be uploaded in specific format to
                ensure Task Manager correctly processes the information. Please{" "}
                <a
                  href={`${
                    process.env.PUBLIC_URL
                  }/templates/RunsheetUploadTemplate.xlsx`}
                  download
                >
                  download
                </a>{" "}
                and view the template before submitting your spreadsheet to
                ensure a successful upload.
              </p>
              <p>Allowed file formats: .xls, .xlsx</p>
            </div>
            <div className="dropzone-container">
              <Files
                className="files-dropzone"
                onChange={this.onFilesChange}
                multiple={false}
                clickable
              >
                Drop file in this space or click to browse for a file on your
                computer
              </Files>
            </div>
          </div>
        );
        modalButton = "";
    }

    return (
      <div>
        <Button
          bsStyle="primary"
          title="Upload Runsheet"
          onClick={this.handleShow}
        >
          <Glyphicon glyph="upload" /> Upload Runsheet
        </Button>

        <Modal
          show={this.state.show}
          backdrop="static"
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Runsheet Batch Upload</Modal.Title>
          </Modal.Header>

          <Modal.Body>{modalBody}</Modal.Body>

          <Modal.Footer>{modalButton}</Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default RunsheetUpload;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/RunsheetUpload.js